import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

// @ commons
import { formatText } from 'core/i18n';

import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
import MessageBox from 'components/commons/MessageBox/MessageBox';

const OtpTransferMessages = ({
    expiredOtpRetry,
    incorrectOtpRetry,
    incorrectOtpWithoutRetry,
    expiredOtpWithoutRetry,
}) => {
    return (
        <Fragment>
            <ConditionalToggling condition={expiredOtpRetry || incorrectOtpRetry}>
                <MessageBox
                    boxColor="red"
                    iconColor="alert-red"
                    contentText={formatText('otpCode-expiredMsgRetryOtp')}
                />
            </ConditionalToggling>

            <ConditionalToggling condition={expiredOtpWithoutRetry || incorrectOtpWithoutRetry}>
                <MessageBox
                    boxColor="red"
                    iconColor="alert-red"
                    contentText={formatText('otpCode-limitOtpCodeTries')}
                />
            </ConditionalToggling>
        </Fragment>
    );
};

OtpTransferMessages.propTypes = {
    isClickedRetryOTPChallenge: PropTypes.bool,
    expiredOtpRetry: PropTypes.bool.isRequired,
    incorrectOtpRetry: PropTypes.bool.isRequired,
    incorrectOtpWithoutRetry: PropTypes.bool.isRequired,
    expiredOtpWithoutRetry: PropTypes.bool.isRequired,
};

export default OtpTransferMessages;
